import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';
import { Button } from '../components/shared/Button';
import { Icon } from '../components/shared/Icons';

// Catchall 404. Lives INSIDE the AppShell route tree so the sidebar + topbar stay visible —
// RequireAuth bounces unauthed visitors to /login before this ever renders, so we don't need a
// standalone variant.
export function NotFoundPage() {
  const { role } = useAuth();
  const navigate = useNavigate();

  // super_admin has no referee Home — its app index is /federations (mirrors RoleHome in App.tsx).
  const homePath = role === 'super_admin' ? '/federations' : '/';
  const homeLabel = role === 'super_admin' ? 'Back to console' : 'Back to home';

  return (
    <div className="grid place-items-center py-24">
      <div className="max-w-md text-center">
        {/* Display-weight numeral; aria-hidden because the headline below already conveys the
            "page not found" meaning to assistive tech — the giant 404 is visual scaffolding. */}
        <div
          aria-hidden
          className="select-none font-display text-[140px] leading-none tracking-tight text-ink-3"
        >
          404
        </div>
        <h1 className="mt-4 text-2xl tracking-tight text-ink">Off the pitch</h1>
        <p className="mt-3 text-sm leading-relaxed text-muted">
          We can't find that page. The link may have moved, or the address might be mistyped.
        </p>
        <div className="mt-7 flex items-center justify-center gap-2.5">
          <Button variant="accent" size="lg" onClick={() => navigate(homePath)}>
            {homeLabel}
            <Icon.arrow className="h-3.5 w-3.5" />
          </Button>
          <Button variant="ghost" size="lg" onClick={() => navigate(-1)}>
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
}
